export const POST_MESSAGES = {
  clearSelectedTradingPhotoCards: 'clear-selected-trading-photo-cards',
  completedNewTradingPhotoCards: 'completed-new-trading-photo-cards'
};
